/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdStepsProps, TdStepItemProps } from './type';

export const stepsDefaultProps: TdStepsProps = {
  currentStatus: 'process',
  layout: 'horizontal',
  readonly: undefined,
  sequence: 'positive',
  theme: 'default',
};

export const stepItemDefaultProps: TdStepItemProps = {
  content: '',
  icon: true,
  status: 'default',
  title: '',
  titleRight: '',
};
